import {
  Device,
  DeviceStatusInfo,
  Diagnostic,
  FaultData,
  ReverseGeocodeAddress,
  User,
  Zone,
} from "@fairfleet/geotab";
import getDeviceLicensePlate from "@/hooks/getDeviceLicensePlate";
import { DiagnosticOverviewData } from "@/models/DiagnosticOverviewData";
import { DiagnosticAddinData } from "@/pages/diagnostic-edit/models/DiagnosticAddinData";
import { resolveDiagnosticOverride } from "@/pages/diagnostic-edit/utils/resolveDiagnosticOverride";

export default function combineData(
  diagnostics: Record<string, Diagnostic>,
  addinData: DiagnosticAddinData[],
  deviceData: Device[],
  faultData: FaultData[],
  statusInfos: Record<string, DeviceStatusInfo>,
  users: User[],
  addresses: Record<string, ReverseGeocodeAddress>,
  zones: { [key: string]: Zone },
): DiagnosticOverviewData[] {
  // combine faultData and statusData in an Array of objects
  return faultData.map(fault => {
    const device = deviceData.find(device => device.id === fault.device.id);

    const deviceGroupIds = device?.groups?.map(g => g.id ?? "").filter(Boolean) ?? [];
    const addIn = resolveDiagnosticOverride(addinData, fault.diagnostic.id, deviceGroupIds);

    const statusInfo = statusInfos[fault.device.id];
    const address = addresses[fault.device.id];

    const findUserName = (id: string) => {
      if (!id) {
        return "";
      }
      users.forEach(user => {
        if (user.id == id) {
          let userName = "";
          users.forEach(user => {
            if (user.id == id) {
              userName = user.name;
            }
          });
          if (userName) {
            return userName;
          }
        }
      });
      return "";
    };

    return {
      id: device?.id + fault.diagnostic?.id,
      deviceId: device?.id ?? "",
      device,
      diagnostic: fault.diagnostic,
      diagnosticId: fault.diagnostic.id,
      deviceName: device ? device.name : "Unknown",
      diagnosticName: fault.diagnostic ? diagnostics[fault.diagnostic.id]?.name : "",
      diagnosticTime: fault.dateTime,
      licensePlate: getDeviceLicensePlate(device),
      statusData: statusInfo !== null ? statusInfo : {},
      driver:
        device?.id && statusInfo && statusInfo !== null
          ? (findUserName(statusInfo?.driver.id ?? "") ?? "")
          : "",
      address: address ? address.formattedAddress : "",
      zones:
        address && address.zones
          ? address.zones
              ?.map(zone => zones[zone.id])
              ?.filter(z => z?.displayed)
              ?.map(z => z?.name)
              ?.join(", ")
          : "",
      allZones:
        address?.zones
          ?.map(zone => zones?.[zone?.id])
          // Reduce amount of data necessary to be stored
          ?.map(z => ({
            name: z?.name,
            id: z?.id,
            fillColor: z?.fillColor,
            displayed: z?.displayed,
          })) ?? [],
      priority: addIn ? addIn.priority : 0,
      instruction: addIn ? addIn.instruction : "",
      description: addIn ? addIn.description : "",
      count: fault.count,
    };
  });
}
